import { uniq } from 'lodash';
import { GeoLocations } from './actionTypes';
import { doRequest } from '../../utils/URLUtils';
import { TrackingUtils } from '../../utils/TrackingUtils';

const requestingGeoLocations = () => ({
    type: GeoLocations.REQUEST_GEO_LOCATIONS,
});

const receiveGeoLocations = (geoLocations) => ({
    type: GeoLocations.RECEIVE_GEO_LOCATIONS,
    geoLocations,
});

const requestingGeoLocationPosition = () => ({
    type: GeoLocations.REQUEST_GEO_LOCATION_POSITION,
});

const receiveGeoLocationPosition = (geoLocationPosition) => ({
    type: GeoLocations.RECEIVE_GEO_LOCATION_POSITION,
    geoLocationPosition,
});

const requestingGeoLocationByIP = () => ({
    type: GeoLocations.REQUEST_GEO_LOCATION_BY_IP,
});

const receiveGeoLocationByIP = (geoLocationByIP) => ({
    type: GeoLocations.RECEIVE_GEO_LOCATION_BY_IP,
    geoLocationByIP,
});

const formatGeoLocations = (geoLocations) => {
    return geoLocations.reduce((map, item) => {
        const prop = item.iata || item.geoNodeId;
        map[prop] = item;
        return map;
    }, {});
};

const extractLocations = (data) => {
    const re = new RegExp(/^(from|to)/);
    const locations = [];
    Object.keys(data).forEach((key) => {
        if (re.exec(key)) {
            const value = data[key];
            if (key.includes('list')) {
                value.split(',').forEach((location) => locations.push(location));
            } else {
                locations.push(value);
            }
        }
    });

    const iatas = [];
    const geoNodes = [];
    locations.forEach((location) => {
        if (location.match(/^\d+$/)) {
            geoNodes.push(location);
        } else {
            iatas.push(location.toUpperCase());
        }
    });

    return { iatas: uniq(iatas), geoNodes: uniq(geoNodes) };
};

const fetchGeoLocations = (data) => {
    const { iatas, geoNodes } = extractLocations(data);
    const url = '/frontend-home/service/geo/locations;';
    const query = iatas
        .map((iata) => `iatas=${iata}`)
        .concat(geoNodes.map((geoNode) => `ids=${geoNode}`))
        .join(';');

    return (dispatch) => {
        dispatch(requestingGeoLocations());
        return doRequest(url + query)
            .then((response) => response.json())
            .then(formatGeoLocations)
            .then((geoLocations) => {
                dispatch(receiveGeoLocations(geoLocations));
            });
    };
};

const shouldFetchGeoLocations = ({ initial, isFetching }) => {
    return initial && !isFetching;
};

export const getGeoLocations = (data) => {
    return (dispatch, getState) => {
        const { geoLocations } = getState();
        if (shouldFetchGeoLocations(geoLocations)) {
            return dispatch(fetchGeoLocations(data));
        } else {
            return Promise.resolve();
        }
    };
};

export const getGeoLocationPosition = (position, transportType) => {
    return (dispatch, getState) => {
        const { geoLocations } = getState();
        const { geoLocated, isGeoLocating } = geoLocations;
        if (geoLocated || isGeoLocating) return Promise.resolve();

        dispatch(requestingGeoLocationPosition());
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
        let url = `/frontend-home/service/geo/geocomplete;latitude=${lat};longitude=${lon}`;
        if (transportType === 'TRAIN' || transportType === 'FLIGHT') {
            url += `;product=${transportType}`;
        }
        return doRequest(url)
            .then((response) => response.json())
            .then((geoLocationPosition) => {
                dispatch(receiveGeoLocationPosition(geoLocationPosition));
            });
    };
};

export const getGeoLocationByIP = () => {
    return (dispatch, getState) => {
        const { geoLocations } = getState();
        const { geoLocatedByIP, isFetchingGeoLocationByIP } = geoLocations;
        if (!geoLocatedByIP && !isFetchingGeoLocationByIP) {
            dispatch(requestingGeoLocationByIP());
            const url = '/frontend-home/service/geo/geolocateIp';
            return doRequest(url)
                .then((response) => response.json())
                .then((geoLocationByIP) => {
                    if (geoLocationByIP.iata) {
                        TrackingUtils.trackEvent({
                            action: TrackingUtils.ACTION.FLIGHTS,
                            label: 'searcher_loads_filled_origin',
                        });
                        dispatch(receiveGeoLocationByIP(geoLocationByIP));
                    } else {
                        dispatch(receiveGeoLocationByIP({}));
                    }
                })
                .catch(() => {
                    dispatch(receiveGeoLocationByIP({}));
                });
        } else {
            return Promise.resolve();
        }
    };
};
